import './Home.css';
import HomeNavbar from './UI/HomeNavbar';
import MediaCard from './UI/Card';
import FrontendImg from '../assets/FrontendImg.jpg';
import BackendImg from '../assets/BackendImg.jpg';
import AndroidImg from '../assets/AndroidImg.jpg';
import MLImg from '../assets/MLImg.jpg';
import GameDevImg from '../assets/GameDevImg.jpg';
import { StyledEngineProvider } from '@mui/material/styles';
import { useEffect, useState } from 'react';
import LoadingModal from './UI/LoadingModal';


const Home = () => {

  const [isLoading, setIsLoading] = useState(true);

  // This will run one time after the component mounts

  useEffect(() => {
    setTimeout(function () {
      console.log("Delayed for 4 second.");
      setIsLoading(false);
    }, 4000);
  }, []);


  return (
    <StyledEngineProvider injectFirst>
      <body>
        {/* <nav>
        <ul>
          <li className="home-logo"><Link to='/'><img src={VITrendzLogo}/></Link></li>
          <div className='search-bar'>
            <img src={SearchIcon} alt='search' style={{padding: '5px', marginLeft: '7px', marginRight: '7px'}}/>
            <input type='text' placeholder='Search your fav domain here' name='search'/>
          </div>
          <li><Link to='/home'><a>Home</a></Link></li>
          <li><Link to='/about'><a href="#">About</a></Link></li>
          <li><Link to='/contact'><a href="#">Contact us</a></Link></li>
          <UserMenu/>
        </ul>
      </nav> */}
        <div className='home-container'>
          <HomeNavbar />
          <div className='heading-container'>
            <h1>Choose a Tech Domain</h1>
          </div>
          <div className="main-container">
            <MediaCard image={FrontendImg} title='Frontend Development' description='Your guide to mastering frontend development: From HTML and CSS basics to dynamic JavaScript and responsive design, this roadmap has you covered.' link='/frontend' />
            <MediaCard image={BackendImg} title='Backend Development' description='Master backend development: Node.js & ExpressJs setup, APIs, MongoDB, Authentication, Error Handling, and deployment strategies.' link='/backend' />
            <MediaCard image={AndroidImg} title='Android Development' description='Explore Android development: From setup and UI design to APIs and deployment strategies, embark on a journey to becoming a skilled Android app developer.' link='/android' />
            <MediaCard image={MLImg} title='Machine Learning' description='Embark on the journey of machine learning: From understanding fundamentals and data preprocessing to building models, exploring deep learning, and deploying ML applications.' link='/ml' />
            <MediaCard image={GameDevImg} title='Game Development' description="Embark on a creative game development journey: Learn, create, code, and deploy captivating experiences with Unity's comprehensive roadmap. " link='/gamedev' />
          </div>
          <LoadingModal isLoading={isLoading} msg={'Loading..'} />
        </div>
      </body>
    </StyledEngineProvider>
  );
}

export default Home;